// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Minoxidil / Finasteride /Biotin    (Men & Women) 09.17.26" (390e3648-3f19-450c-8d84-737d12327a18). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiMinoxidilFinasterideBiotinMenWomenAnswerField } from './questions';

export const mdiMinoxidilFinasterideBiotinMenWomen: FormType<mdiMinoxidilFinasterideBiotinMenWomenAnswerField> =
  {
    name: 'Minoxidil / Finasteride /Biotin (Men & Women)',
    validityLength: 25,
    questions: [
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_sex',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_pregnancy'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_pregnancy.yes': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryDueEitherBeing'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_sex.male': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryBasedPreviousResponse'
            }
          ],
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_primaryConcern'
        }
      },
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_pregnancy',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_pregnancy.yes': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryDueEitherBeing'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_sex.male': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryBasedPreviousResponse'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_requiredAcknowledgmentUnderstandFormulationContains'
            }
          ],
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_primaryConcern'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryDueEitherBeing',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_tryingConceivePlanConceivingNear',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryBasedPreviousResponse'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_requiredAcknowledgmentUnderstandFormulationContains'
            }
          ],
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_primaryConcern'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_wereSorryBasedPreviousResponse',
      'mdiMinoxidilFinasterideBiotinMenWomen_requiredAcknowledgmentUnderstandFormulationContains',
      'mdiMinoxidilFinasterideBiotinMenWomen_primaryConcern',
      'mdiMinoxidilFinasterideBiotinMenWomen_didFirstNoticeHairLoss',
      'mdiMinoxidilFinasterideBiotinMenWomen_whereHairLossOccurring',
      'mdiMinoxidilFinasterideBiotinMenWomen_hairLoss',
      'mdiMinoxidilFinasterideBiotinMenWomen_familyHistoryHairLoss',
      'mdiMinoxidilFinasterideBiotinMenWomen_conditions',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_everDiagnosed',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_everDiagnosed.androgenetic_alopecia':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_everDiagnosed.alopecia_areata':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_everDiagnosed.telogen_effluvium':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding'
            }
          ],
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_usingHairLossTreatmentsIncludes'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding',
      'mdiMinoxidilFinasterideBiotinMenWomen_usingHairLossTreatmentsIncludes',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts.minoxidil':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts.retinoids_e_g_tretinoin':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts.finasteride':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts.dutasteride':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts.ketoconazole_shampoo':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts.microneedling':
                  true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_youuseProducts.prp': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried'
            }
          ],
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_scalpIrritationOpenWoundsInfection'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_experienceProductsTried',
      'mdiMinoxidilFinasterideBiotinMenWomen_scalpIrritationOpenWoundsInfection',
      'mdiMinoxidilFinasterideBiotinMenWomen_redness',
      'mdiMinoxidilFinasterideBiotinMenWomen_history',
      'mdiMinoxidilFinasterideBiotinMenWomen_usingScalp',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_historyLowBloodPressureDizziness',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experiencedDecreasedLibidoLately'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideBiotinMenWomen_sex.male': true
              },
              key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienced'
            }
          ],
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_fertilityConcerns'
        }
      },
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_experiencedDecreasedLibidoLately',
        next: {
          condition: { 'mdiMinoxidilFinasterideBiotinMenWomen_sex.male': true },
          key: 'mdiMinoxidilFinasterideBiotinMenWomen_experienced',
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_fertilityConcerns'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_experienced',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_fertilityConcerns',
        next: {
          condition: {
            'mdiMinoxidilFinasterideBiotinMenWomen_fertilityConcerns.yes': true
          },
          key: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding2',
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_historyDepressionAnxietyMoodDisorders'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRegarding2',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_historyDepressionAnxietyMoodDisorders',
        next: {
          condition: {
            'mdiMinoxidilFinasterideBiotinMenWomen_historyDepressionAnxietyMoodDisorders.yes':
              true
          },
          key: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorFurtherInsightHistory',
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_history2'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorFurtherInsightHistory',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_history2',
        next: {
          condition: { 'mdiMinoxidilFinasterideBiotinMenWomen_sex.male': true },
          key: 'mdiMinoxidilFinasterideBiotinMenWomen_ever',
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_rateStressLevelDailyBasis'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_ever',
      'mdiMinoxidilFinasterideBiotinMenWomen_rateStressLevelDailyBasis',
      {
        key: 'mdiMinoxidilFinasterideBiotinMenWomen_experiencedRecentMajorStressIllness',
        next: {
          condition: {
            'mdiMinoxidilFinasterideBiotinMenWomen_experiencedRecentMajorStressIllness.yes':
              true
          },
          key: 'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRecent',
          els: 'mdiMinoxidilFinasterideBiotinMenWomen_uploadClearWellLitPhoto'
        }
      },
      'mdiMinoxidilFinasterideBiotinMenWomen_provideDoctorMoreInsightRecent',
      'mdiMinoxidilFinasterideBiotinMenWomen_uploadClearWellLitPhoto',
      'mdiMinoxidilFinasterideBiotinMenWomen_importantClickAttachedLinkReview',
      'mdiMinoxidilFinasterideBiotinMenWomen_firstMessageDoctor',
      'mdiMinoxidilFinasterideBiotinMenWomen_complete'
    ]
  };
